import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import * as LucideIcons from 'lucide-react';

const SubTopicCard = ({ icon: Icon, text }) => (
  <div
    className={`
      relative overflow-hidden
      bg-transparent rounded-xl p-4 md:p-8
      transform transition-all duration-500 ease-out
      hover:scale-105 
      group
      flex flex-col items-center
    `}
  >
    {/* Background Gradient Effect */}
    <div className="absolute inset-0 bg-gradient-to-br  opacity-0 group-hover:opacity-100 transition-opacity duration-500"/>
    
    {/* Icon Container */}
    <div className="relative mb-4 flex justify-center">
      <div className="w-12 h-12 md:w-16 md:h-16 rounded-xl bg-gradient-to-r from-[#97a9b6] to-[#9bc4e4] p-3 md:p-4 transform transition-transform group-hover:rotate-6">
        <Icon className="w-full h-full text-white" />
      </div>
    </div>

    {/* Content */}
    <h3 className="text-base md:text-xl font-bold mb-2 text-gray-800 group-hover:text-[#9bc4e4]transition-colors duration-300 text-center">
      {text}
    </h3>

    {/* Bottom Line Decoration */}
    <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r  transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500"/>
  </div>
);

const SubTopicsGrid = ({ subSubjects }) => {
  return (
    <div className="mb-12">
      <div className="flex items-center mb-6">
        <BookOpenIcon className="w-6 h-6 text-[#64748b] ml-2" />
        <h2 className="text-2xl font-semibold text-gray-900">התמחויות</h2>
      </div>

      <div className="space-y-4 md:space-y-8">
        {/* First Row */}
        <div className="grid grid-cols-3 gap-2 md:gap-8">
          {subSubjects.slice(0, 3).map((subTopic, index) => {
            const text = typeof subTopic === 'string' ? subTopic : subTopic.text;
            const IconComponent = subTopic.icon ? LucideIcons[subTopic.icon] : BookOpenIcon;

            return (
              <SubTopicCard
                key={index}
                icon={IconComponent}
                text={text}
              />
            );
          })}
        </div>

        {/* Second Row */}
        {subSubjects.length > 3 && (
          <div className="grid grid-cols-3 gap-2 md:gap-8">
            {subSubjects.slice(3, 6).map((subTopic, index) => {
              const text = typeof subTopic === 'string' ? subTopic : subTopic.text;
              const IconComponent = subTopic.icon ? LucideIcons[subTopic.icon] : BookOpenIcon;

              return (
                <SubTopicCard
                  key={index + 3}
                  icon={IconComponent}
                  text={text}
                />
              );
            })}
          </div>
        )}

        {/* Third Row - New row for items 7, 8, 9 */}
        {subSubjects.length > 6 && (
          <div className="grid grid-cols-3 gap-2 md:gap-8">
            {subSubjects.slice(6, 9).map((subTopic, index) => {
              const text = typeof subTopic === 'string' ? subTopic : subTopic.text;
              const IconComponent = subTopic.icon ? LucideIcons[subTopic.icon] : BookOpenIcon;

              return (
                <SubTopicCard
                  key={index + 6}
                  icon={IconComponent}
                  text={text}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default SubTopicsGrid;